import { XIcon } from 'assests/GmsIcons';
import React from 'react';

interface CustomLayoutDialogProps {
  onClose: () => void;
}

const CustomLayoutDialog: React.FC<CustomLayoutDialogProps> = ({ onClose }) => {

  return (
    <div className={`tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-gray-800 tw-bg-opacity-50`}>
      <div className={`tw-bg-white tw-rounded tw-shadow-md tw-w-[730px] tw-h-auto`}>
        <div className={`tw-flex tw-justify-between tw-items-center tw-pe-3`}>
          <h2 className={`tw-text-sm tw-font-semibold tw-my-3 tw-mx-3`}>Create Layout</h2>
          <span onClick={onClose}><XIcon /></span>
        </div>
        <div className={`tw-box-border tw-w-auto tw-h-px tw-border-t-[1px] tw-border-solid tw-border-[#D1D1D6]`} />
        <div className={`tw-mx-3 tw-my-3 `}>
          <label className={`tw-font-normal tw-w-full tw-text-sm tw-text-[#091E42] `}>Name</label>
          <input type='text' className={`tw-mt-1 tw-border tw-border-[#C9C9CF] tw-px-[10px] tw-gap-2.5 tw-py-1 tw-bg-white tw-w-[330px] tw-rounded focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-gray-300`} placeholder='Layout Name' />
        </div>
        <div className={`tw-mx-1 tw-my-3 `}>
          <div className={`tw-grid tw-grid-cols-3 tw-gap-3.5 tw-px-3 tw-py-2`}>
            {/* {MOCK_DATA.map((data, index) => (
              <label key={index} className={`tw-flex tw-items-center tw-space-x-2`}>
                <input
                  type="checkbox"
                  className={`tw-rounded tw-form-checkbox tw-text-[#091CAA] tw-h-4 tw-w-4 tw-border tw-border-solid tw-border-[#C9C9CF]`}
                  name={data.name}
                  value={data.name}
                />
                <span className={`tw-text-xs tw-text-[#091E42]`}>{data.name}</span>
              </label>
            ))} */}
          </div>
        </div>
        <div className={`tw-my-4 tw-mx-[30px] tw-justify-end tw-flex tw-gap-2`}>
          <button className={`tw-outline-button`} onClick={ onClose }>Cancel</button>
          <button onClick={() => null} className={`button-style`}>Create</button>
        </div>
      </div>
    </div>
  );
};

export default CustomLayoutDialog;
